// src/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// If you want analytics, guard it so it doesn't crash on http/local
// import { getAnalytics, isSupported as analyticsIsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCJDGlD9EvgC6DCl7V3HA0Aclo3tre0kdc',
  authDomain: 'planmyguest.firebaseapp.com',
  projectId: 'planmyguest',
  storageBucket: 'planmyguest.firebasestorage.app', // ✅ matches console
  messagingSenderId: '1028033774667',
  appId: '1:1028033774667:web:38cfbde98a7334924439ce',
  measurementId: 'G-RZ98NKHD5F',
};

const app = initializeApp(firebaseConfig);

// Optional analytics (safe-guarded)
// (async () => {
//   if (await analyticsIsSupported()) {
//     getAnalytics(app);
//   }
// })();

export const auth = getAuth(app);
export const db = getFirestore(app);

// Be explicit with gs:// bucket too
export const storage = getStorage(app, 'gs://planmyguest.firebasestorage.app');

// Re-export helpers so you can import from '../firebase/firebase'
export {
  // Firestore
  collection,
  addDoc,
  setDoc,
  doc,
  getDoc,
  serverTimestamp,
} from 'firebase/firestore';

export {
  // Storage
  ref,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';
